const d3 = require('d3'),
  topojson = require('topojson');

import {gVars} from './00-global-init.js';
import {svgElements} from './00-global-functions.js';
import {loadData} from './02-map-shapes.js';

export function addSVG(wrapper_id) {
  var all_years,
    overlay = null,
    zoom_hod = null,
    vtds = null;

  // Our maps
  if (wrapper_id == gVars.map_key) {
    all_years = [2016];
  } else if (wrapper_id == gVars.map_vtds) {
    all_years = [2008, 2010, 2012];
    vtds = true;
  } else if (wrapper_id == gVars.map_mini) {
    all_years = gVars.all_years;
  } else if (wrapper_id == gVars.map_redistricting) {
    all_years = [1982, 1992, 2002, 2012];
  } else if (wrapper_id == gVars.map_farenthold_home) {
    all_years = [2010, 2012, 2014];
    vtds = true;
  } else if (wrapper_id == gVars.map_hispanic) {
    all_years = [2010, 2012];
    overlay = 'hispanic';
  } else if (wrapper_id == gVars.map_hod) {
    all_years = [2010, 2012];
  } else if (wrapper_id == gVars.map_hod_zoom) {
    all_years = [2010, 2012];
    zoom_hod = true;
  }

  // Clear old stuff
  var wrapper = d3.select(wrapper_id + '-key-wrapper');
  var map_wrapper = wrapper.select('.maps-maps-wrapper');
  var key_wrapper = wrapper.select('.key-wrapper');
  var overlay_key = wrapper.select('.overlay-key');
  var key_map = d3.select('#maps-maps-wrapper-key');
  map_wrapper.html('');
  key_wrapper.remove();
  overlay_key.remove();

  if (wrapper_id == gVars.map_key) {
    key_map.html('');
  }

  for (var x = 0; x < all_years.length; x++) {
    var c_year = all_years[x],
      win_party;

    if (c_year < 2010) {
      win_party = 'Democrat';
    } else {
      win_party = 'Republican';
    }

    // Point out 2012 specifically
    if (wrapper_id == gVars.map_mini && c_year == 2012) {
      var container = map_wrapper.append('div')
        .attr('id', 'map-2012-notation')
        .attr('class', 'key-container map-container')
        .style('margin-left', '0px')
        .style('width', gVars.width_mini + 'px');
      var square_container = container.append('div')
        .attr('class', 'square-container')
        .html('After the GOP wave, lawmakers in 2011 changed the shape of CD-27 significantly, which helped Farenthold get re-elected the following year →');
    }

    // Loads topojson data
    var iter_array = [x + 1, all_years.length];
    loadData(
      c_year, svgElements(c_year, wrapper_id, iter_array), all_years[0], overlay, iter_array, zoom_hod, vtds
    );
  }
}



// WEBPACK FOOTER //
// ./01-map-load-data.js